import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, withKeys as _withKeys, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "closed-deposit-detail-table px-4 py-2" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("th", null, "NO. KARCIS"),
  /*#__PURE__*/_createElementVNode("th", null, "ASAL - TUJUAN"),
  /*#__PURE__*/_createElementVNode("th", null, "RIT"),
  /*#__PURE__*/_createElementVNode("th", null, "NON-TUNAI"),
  /*#__PURE__*/_createElementVNode("th", null, "ONLINE"),
  /*#__PURE__*/_createElementVNode("th", null, "TUNAI")
], -1)
const _hoisted_3 = { key: 1 }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("td", {
  colspan: "6",
  class: "text-center text-xs text-grey p-2",
  style: {"text-align":"center"}
}, "Tidak Ada Data", -1)
const _hoisted_5 = [
  _hoisted_4
]

import apiUseCase from '@/usecase/apiUseCase'
import numberFormat from '@/utils/helpers/numberFormat'
import returnUrlPrams from '@/utils/helpers/returnUrlPrams'
import currencyNumberFormat from '@/utils/helpers/rupiahFormat'
import { ref, computed, onMounted, getCurrentInstance } from 'vue'
import { useStore } from 'vuex'
import Paginator from '@/views/components/paginator/Paginator.vue'
import InputIconRight from '@/views/components/form/InputIconRight.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'TicketListDetail',
  props: {
  transactionId: {
    type: String,
    default: null
  }
},
  setup(__props) {

const props = __props



const transactionPpsEndpoint = 'transaction/v2/TransactionPps'
const app = getCurrentInstance()
const {
  $toast, $strInd, $icon
} = app!.appContext.config.globalProperties
const icon = $icon
const dataSource = ref([]) as any
const store = useStore()
const transactionId = computed(() => props.transactionId)
const inputSearch = ref('')

const filters = ref({
  search: '',
  filterField: ['q'],
  pageNumber: 1,
  pageSize: 5,
  totalRecords: 0,
  custom: [] as any
})

const getAllData = async () => {
  store.dispatch('showLoading')
  await apiUseCase.get(`${transactionPpsEndpoint}/NonCash/Approved/${transactionId.value}/Tickets`, returnUrlPrams(filters.value)).then((response) => {
    const { error, result, count } = response
    console.log('res', result)
    if (!error) {
      filters.value.totalRecords = count
      dataSource.value = result
    }
  })
  store.dispatch('hideLoading')
}

const onChangePage = ({ page, rows }: any) => {
  filters.value.pageNumber = page + 1
  filters.value.pageSize = rows
  // eslint-disable-next-line no-use-before-define
  getAllData()
}

const onSearch = () => {
  filters.value.search = inputSearch.value
  filters.value.pageNumber = 1
  getAllData()
}

onMounted(() => {
  getAllData()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(InputIconRight, {
      class: "input-search-header-custom",
      placeholder: "Cari Disini...",
      modelValue: inputSearch.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((inputSearch).value = $event)),
      canClick: true,
      icon: _unref($icon).svg.searchEva,
      onSubmitInput: onSearch,
      onKeyup: _withKeys(onSearch, ["enter"])
    }, null, 8, ["modelValue", "icon", "onKeyup"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("table", null, [
        _hoisted_2,
        (_unref(dataSource).length > 0)
          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_unref(dataSource), (dataDetail) => {
              return (_openBlock(), _createElementBlock("tr", { key: dataDetail }, [
                _createElementVNode("td", null, _toDisplayString(dataDetail?.Code ?? '-'), 1),
                _createElementVNode("td", null, _toDisplayString(`${dataDetail.OriginTerminalCode} - ${dataDetail.DestinationTerminalCode}`), 1),
                _createElementVNode("td", null, _toDisplayString(_unref(numberFormat)(dataDetail?.RitOrder)), 1),
                _createElementVNode("td", null, _toDisplayString(dataDetail?.PaymentType.toLowerCase() === 'nontunai' ? _unref(currencyNumberFormat)(dataDetail?.Price ?? 0) : '-'), 1),
                _createElementVNode("td", null, _toDisplayString(dataDetail?.PaymentType.toLowerCase() === 'online' ? _unref(currencyNumberFormat)(dataDetail?.Price ?? 0) : '-'), 1),
                _createElementVNode("td", null, _toDisplayString(dataDetail?.PaymentType.toLowerCase() === 'tunai' ? _unref(currencyNumberFormat)(dataDetail?.Price ?? 0) : '-'), 1)
              ]))
            }), 128))
          : (_openBlock(), _createElementBlock("tr", _hoisted_3, _hoisted_5))
      ])
    ]),
    _createElementVNode("div", null, [
      _createVNode(Paginator, {
        rows: filters.value.pageSize,
        totalRecords: filters.value.totalRecords,
        rowsPerPageOptions: [5, 10, 15, 20, 25],
        onOnPage: onChangePage
      }, null, 8, ["rows", "totalRecords"])
    ])
  ]))
}
}

})